export default __webpack_public_path__ + "static/media/ArrowUpFilled.323992e3.svg";